import { useMemo, useState } from 'react'
import { debounce } from '@mui/material/utils'

import { Options } from '../utils'
import { User } from '../types'
import { useLazySearchUserQuery } from '../services/user'

export const useFetchUsers = () => {
  const [searchUser, lastArg] = useLazySearchUserQuery()
  const [loading, setLoading] = useState(false)
  const [users, setUsers] = useState<(Options & User)[]>([])

  const fetch = useMemo(
    () =>
      debounce((request: string | null) => {
        if (!request || lastArg.originalArgs === request) return

        setLoading(true)
        searchUser(request)
          .then(data => {
            setUsers(
              data.data?.map(user => ({
                ...user,
                value: String(user.id),
                label: `${user.first_name} ${user.last_name}`,
              })) ?? []
            )
            setLoading(false)
          })
          .catch(() => {
            setLoading(false)
          })
      }, 600),
    [searchUser, lastArg]
  )

  return { fetch, loading, users }
}

export const toDataURL = (url: string): Promise<string> =>
  fetch(url)
    .then(response => response.blob())
    .then(
      blob =>
        new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.onloadend = () => resolve(reader.result as string)
          reader.onerror = reject
          reader.readAsDataURL(blob)
        })
    )

export const convertToFile = (uri: string) => {
  const byteString = atob(uri.split(',')[1])
  const mimeString = uri.split(',')[0].split(':')[1].split(';')[0]
  const ab = new ArrayBuffer(byteString.length)
  const ia = new Uint8Array(ab)
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i)
  }
  return new Blob([ab], { type: mimeString })
}
